import { tracked } from '@glimmer/tracking';
import JournalContactDetailModel from 'donor-elf-web/models/all-funds/journal-contact-detail';
import JournalDecisionModel from 'donor-elf-web/models/journal-decision';
import JournalGoalModel from 'donor-elf-web/models/journal-goal';
import PledgeModel from 'donor-elf-web/models/pledge';
import JournalInfo from './journal-info';

export default class JournalDecisionInfo {
  constructor(args: {
    journalDecision: JournalDecisionModel;
    journalContactDetailModel: JournalContactDetailModel;
    journalInfo: JournalInfo;
  }) {
    this.journalDecision = args.journalDecision;
    this.journalGoal =
      args.journalInfo.goalsById[this.journalDecision.journalGoalId];
    if (this.journalDecision.yesNo) {
      this.pledge = args.journalContactDetailModel.pledges.find(
        (x) => x.id === this.journalDecision.pledgeId,
      );
    }
  }

  @tracked journalDecision: JournalDecisionModel;
  @tracked journalGoal: JournalGoalModel;
  @tracked pledge?: PledgeModel;
}
